module.exports = __webpack_public_path__ + "static/media/cardapio_checkout.5dfa6070.png";